import React, {Component} from 'react';

class GroupHeader extends Component {
  render() {
    const {children} = this.props;
    return (
      <div className="group-header">
        <h3>
          <span className="title">
            {children}
          </span>
        </h3>
        <hr/>
      </div>
    );
  }
}

export default GroupHeader;



// WEBPACK FOOTER //
// ./src/components/product-page/filters/group-header.jsx